<template>
  <div class="cutters-comparison" :style="containerStyle">
    <div class="begin-video" :style="videoContainerStyle">
      <video autoplay muted playsinline @ended="onVideoEnded" :style="videoStyle">
        <source :src="src" type="video/mp4">
      </video>
    </div>
    <!-- 视频播放完成后的固定图片 -->
    <div class="video-end" :style="videoContainerStyle">
      <img src="../../static/series/cutbed/knife_back_show.png" alt="" :style="videoStyle">
    </div>
    <!-- 滑动的黑色背景层 -->
    <div class="bg-black" ref="blackBg" :style="bgStyle"></div>
    <!-- 裁刀对比区域 -->
    <div class="cutters-wrapper" ref="cuttersWrapper" :style="wrapperStyle">
      <!-- S6裁刀 -->
      <div class="cutter-item s6-cutter" ref="cutterS6" :style="itemStyle">
        <div class="cutter-image-container" ref="cutterS6ImgContainer" :style="imageContainerStyle">
          <img
              src="../../static/series/knife1.png"
              alt="S6裁刀"
              class="cutter-image-knife"
              ref="cutterS6Img"
              @load="onImageLoaded"
              :style="imageStyle"
          >
        </div>
        <div class="cutter-info" ref="cutterS6Info" :style="infoStyle">
          <p class="cutter-model" ref="cutterS6Model" :style="modelStyle">S6</p>
          <p class="cutter-spec" ref="cutterS6Spec" :style="specStyle">2 x 7 mm</p>
        </div>
      </div>
      <!-- S9裁刀 -->
      <div class="cutter-item2 s9-cutter" ref="cutterS9" :style="itemStyle">
        <div class="cutter-image-container" ref="cutterS9ImgContainer" :style="imageContainerStyle">
          <img
              src="../../static/series/knife2.png"
              alt="S9裁刀"
              class="cutter-image-knife"
              ref="cutterS9Img"
              @load="onImageLoaded"
              :style="s9ImageStyle"
          >
        </div>
        <div class="cutter-info" ref="cutterS9Info" :style="infoStyle">
          <p class="cutter-model" ref="cutterS9Model" :style="modelStyle">S9</p>
          <p class="cutter-spec" ref="cutterS9Spec" :style="specStyle">2.4 x 8.5 mm</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import taishi_video from "../../static/taishi_video.mp4"

export default {
  name: 'TwoKnife',
  data() {
    return {
      src: taishi_video,
      loadedImages: 0,
      totalImages: 2,
      timeline: null,
      isMobile: false,
      scale: 1 // 缩放比例，电脑端为1，手机端按比例计算
    }
  },
  computed: {
    // 容器样式计算（仅手机端应用缩放）
    containerStyle() {
      if (!this.isMobile) return {}
      return {
        height: `${1000 * this.scale}px`,
        marginBottom: `${200 * this.scale}px`
      }
    },
    // 视频容器样式
    videoContainerStyle() {
      if (!this.isMobile) return {}
      return {
        height: `${1000 * this.scale}px`
      }
    },
    // 视频和图片样式
    videoStyle() {
      if (!this.isMobile) return {}
      return {
        height: `${1000 * this.scale}px`
      }
    },
    // 黑色背景样式
    bgStyle() {
      if (!this.isMobile) return {}
      return {
        height: `${1000 * this.scale}px`
      }
    },
    // 包裹容器样式
    wrapperStyle() {
      if (!this.isMobile) return {}
      return {
        padding: `0 ${40 * this.scale}px`,
        height: `${1000 * this.scale}px`
      }
    },
    // 裁刀项样式
    itemStyle() {
      if (!this.isMobile) return {}
      return {
        width: '45%' // 保持宽度比例
      }
    },
    // 图片容器样式
    imageContainerStyle() {
      if (!this.isMobile) return {}
      return {
        marginBottom: `${20 * this.scale}px`
      }
    },
    // 图片样式
    imageStyle() {
      if (!this.isMobile) return {}
      return {
        maxWidth: `${140 * this.scale}px`
      }
    },
    // S9图片特殊样式（保持130%比例）
    s9ImageStyle() {
      if (!this.isMobile) return {}
      return {
        maxWidth: `${140 * this.scale}px`,
        width: '130%'
      }
    },
    // 信息区域样式
    infoStyle() {
      if (!this.isMobile) return {}
      return {
        width: '100%'
      }
    },
    // 型号文字样式
    modelStyle() {
      if (!this.isMobile) return {}
      return {
        fontSize: `${2 * this.scale}em`,
        marginBottom: `${8 * this.scale}px`
      }
    },
    // 规格文字样式
    specStyle() {
      if (!this.isMobile) return {}
      return {
        fontSize: `${1.5 * this.scale}em`,
        width: `${285 * this.scale}px`
      }
    }
  },
  mounted() {
    // 检测设备类型并计算缩放比例
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);

    this.$nextTick(() => {
      if (this.loadedImages >= this.totalImages) {
        this.initAnimation();
      }
    });
  },
  methods: {
    onVideoEnded() {
      // 视频结束显示图片（保持原逻辑）
      this.$gsap.set('.video-end', {
        opacity: 1
      });
    },
    // 检测设备类型并计算缩放比例
    checkDevice() {
      const isMobile = window.innerWidth < 768;
      // 手机端按屏幕宽度与电脑端宽度比例计算缩放值（电脑端基准宽度1920px）
      this.scale = isMobile ? Math.min(window.innerWidth / 1920, 0.7) : 1;

      if (isMobile !== this.isMobile) {
        this.isMobile = isMobile;
        if (this.loadedImages >= this.totalImages) {
          this.initAnimation();
        }
      }
    },
    onImageLoaded() {
      this.loadedImages++;
      if (this.loadedImages >= this.totalImages) {
        this.initAnimation();
      }
    },
    initAnimation() {
      const items = document.querySelectorAll('.cutter-image-container');
      if (items.length === 0) return;

      // 基于缩放比例的初始动画配置
      const initialConfig = this.isMobile
          ? {
            y: 50 * this.scale,
            rotate: -20,
            scale: 1.1
          }
          : {
            y: 100,
            rotate: -30,
            scale: 1.2
          };

      this.$gsap.set(items, {
        ...initialConfig,
        visibility: 'visible',
        opacity: 0
      });

      // 清理之前的时间线
      if (this.timeline && this.timeline.scrollTrigger) {
        this.timeline.scrollTrigger.kill();
      }

      // 创建主时间线（保持原触发逻辑）
      this.timeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: this.$refs.cuttersWrapper,
          start: this.isMobile ? 'top 80%' : 'top 90%',
          end: this.isMobile ? 'bottom 60%' : 'bottom 50%',
          markers: false,
          toggleActions: 'play none none none',
          invalidateOnRefresh: true,
          once: true
        }
      });

      // 入场动画（按比例调整时长）
      this.timeline.to(items, {
        y: 0,
        opacity: 1,
        duration: this.isMobile ? 0.8 : 1,
        rotate: 0,
        scale: 1,
        ease: 'power3.in',
        onComplete: this.startSecondPhaseAnimation
      });
    },
    startSecondPhaseAnimation() {
      const blackBg = this.$refs.blackBg;
      if (!blackBg) return;

      const textItems = document.querySelectorAll('.cutter-info');
      const items = document.querySelectorAll('.cutter-image-container');

      this.$gsap.set(blackBg, {y: "100%", opacity: 0});

      // 按缩放比例计算所有动画参数
      const animationConfig = this.isMobile ? {
        textY: -150 * this.scale,
        textDuration: 1.5,
        item1X: 80 * this.scale,
        item1Y: -50 * this.scale,
        item1Duration: 2,
        item2X: -60 * this.scale,
        item2Y: 150 * this.scale,
        item2Duration: 2.2,
        bgDuration: 1.5,
        delay: 0.3
      } : {
        textY: -300,
        textDuration: 2,
        item1X: 150,
        item1Y: -100,
        item1Duration: 2.3,
        item2X: -120,
        item2Y: 300,
        item2Duration: 2.5,
        bgDuration: 2,
        delay: 0.5
      };

      const secondTimeline = this.$gsap.timeline({});

      // 保持原动画序列，仅参数按比例缩放
      secondTimeline.to(textItems, {
        y: animationConfig.textY,
        opacity: 0,
        duration: animationConfig.textDuration,
        ease: 'power3.in'
      }, 0);

      secondTimeline.to(items[0], {
        x: animationConfig.item1X,
        y: animationConfig.item1Y,
        duration: animationConfig.item1Duration,
        opacity: 0,
        rotate: -180,
        scale: 0.5,
        ease: 'power3.in'
      }, 0);

      secondTimeline.to(items[1], {
        opacity: 1,
        x: animationConfig.item2X,
        y: animationConfig.item2Y,
        duration: animationConfig.item2Duration,
        rotate: -180,
        scale: 0.5,
        ease: 'power3.in'
      }, 0);

      secondTimeline.to(blackBg, {
        y: 0,
        opacity: 1,
        duration: animationConfig.bgDuration,
        ease: 'power3.in'
      }, 0);

      secondTimeline.add(() => {
        this.$gsap.set(blackBg, {opacity: 0})
        this.$gsap.set(items[1], {opacity: 0})
        this.$gsap.to('.begin-video', {opacity: 1, duration: 0.5});
      }, `+=${animationConfig.delay}`);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
    if (this.timeline && this.timeline.scrollTrigger) {
      this.timeline.scrollTrigger.kill();
    }
  }
}
</script>

<style scoped>
/* 电脑端样式保持不变 */
.video-end {
  position: absolute;
  opacity: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  object-fit: cover;
  box-sizing: border-box;

  img {
    height: 100%;
    width: 100%;
  }
}

.cutters-comparison {
  position: relative;
  text-align: center;
  width: 100%;
  height: 1000px;
  margin-bottom: 200px;
}

.begin-video {
  position: absolute;
  opacity: 0;
  overflow: hidden;
  width: 100%;
  left: 0;
  top: 0;
  object-fit: cover;
  box-sizing: border-box;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.bg-black {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  will-change: transform;
  opacity: 0;
  z-index: 10;
}

.cutters-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  position: relative;
  z-index: 20;
  height: 100%;
}

.cutter-item {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  width: 45%;
}

.cutter-item2 {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 45%;
}

.cutter-image-container {
  margin-bottom: 20px;
}

.cutter-image-knife {
  max-width: 140px;
  height: auto;
}

.cutter-info {
  text-align: center;
  width: 100%;
  display: grid;
  justify-content: center;
  position: relative;
  z-index: 20;
}

.cutter-model {
  font-size: 2em;
  color: #333;
  margin: 0 0 8px;
}

.cutter-spec {
  font-size: 1.5em;
  margin: 0;
  width: 285px;
}

.s6-cutter .cutter-spec {
  color: #C8369D;
}

.s9-cutter .cutter-spec {
  color: #55B9E6;
}

/* 移除原手机端样式，完全通过JS计算实现同比缩放 */
</style>
